var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:`${
      Object.hasOwnProperty.apply('game', _vm.telemetry.game)
        ? _vm.telemetry.game.game.name
        : ''
    }`},[_c('HistoryOverlay'),_c('Overlay'),(_vm.$telemetryDataIsEnough())?_c('TelemetryEventOverlay'):_vm._e(),(_vm.$telemetryDataIsEnough())?_c('Header'):_vm._e(),(_vm.$telemetryDataIsEnough())?_c(_vm.currentSkinComponent(),{directives:[{name:"show",rawName:"v-show",value:(!_vm.menuIsDisplayed),expression:"!menuIsDisplayed"}],tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }